import classNames from "classnames";
import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";
import { UpdateRegistrationSteps } from "../../../../../../connection/create-event";
import { chooseRegistrationStep, loadWorkingEvent, updateRegistrationSteps } from "../../../../../../store/actions/admin/create-event";
import { EventsState } from "../../../../../../store/types";
import { GetDefaultRegistrationSteps } from "../../../../../../store/utils/create-event";
import { REGISTRATION_STEP_NAME_MAP } from "../../../../../../types/working-model";
import Icon, { COLORS, ICONS } from "../../../../../general-ui/icon";
import { ParamsProps } from "../../../../../live-event/live-event";
import { PATHNAMES } from "../../../../admin";
import { switchingLanguageAlert } from "../header/header";

const RegistrationStepsHeader: React.FC = () => {
	const {
		CreateEventReducer: {
			registrationStep,
			workingEvent
		},
		AuthReducer: {
			token
		}
	} = useSelector((state: EventsState) => state);
	const dispatch = useDispatch();
	const history = useHistory();
	const { language, id, tab } = useParams() as ParamsProps;
	const registrationSteps = workingEvent?.registration_steps;

	useEffect(() => {
		if (workingEvent && !registrationSteps?.length) {
			console.log("Getting default registration steps");
			const defaultSteps = GetDefaultRegistrationSteps();

			dispatch(updateRegistrationSteps(defaultSteps));
			UpdateRegistrationSteps(token!, workingEvent!.uuid, defaultSteps);
		}
	}, [workingEvent, registrationSteps, dispatch, token]);

	//currently for homepage and registration enligh will always be the default, put that first
	const sortedLanguages = useMemo(() => {
		if (!workingEvent) return ["en"];
		//get list from homepage or aggrigate from sessions if they dont exist
		const list = workingEvent.homepage ? workingEvent.homepage.languages : workingEvent.sessions.map(session => session.languages).flat();
		const languagesSet = new Set(list);
		languagesSet.delete("en");
		const languages: string[] = Array.from(languagesSet);
		return ["en", ...languages.sort()];
	}, [workingEvent]);

	const navButtons = useMemo(() => {
		if (!registrationSteps?.length) return <></>;
		return registrationSteps
			.filter(step => step.isOn)
			.map((step, index) => {
				return <React.Fragment key={index}>
					{index !== 0 && <Icon name={ICONS.KEYBOARD_ARROW_RIGHT} color={COLORS.GRAY} size={12} />}
					<button
						className={classNames("small", { active: registrationStep === step.type })}
						onClick={() => dispatch(chooseRegistrationStep(step.type))}
					>{REGISTRATION_STEP_NAME_MAP[step.type].toLocaleUpperCase()}</button>
				</React.Fragment>;
			});
	}, [registrationSteps, registrationStep, dispatch]);

	const handleLanguageClick = (language: string) => () => {
		switchingLanguageAlert();

		dispatch(loadWorkingEvent(id, token!));

		history.push(PATHNAMES.Event.RegistrationLink(id, language, tab));
	};

	return (
		<div className="registration-steps-header">
			<div>
				<h4>Registration Steps</h4>
				<div className="registration-steps-button-container">
					{navButtons}
				</div>
			</div>

			<div>
				<h4>Language</h4>
				<div className="registration-steps-button-container">
					{sortedLanguages.map((_language: string, index: number) => {
						if (index < 11) {
							return (
								<button
									key={_language}
									className={classNames({ active: _language === language }, "registration-langauge-item small")}
									onClick={handleLanguageClick(_language)}
								>
									{_language}
								</button>
							);
						}
					})}
					{sortedLanguages.length >= 11 && (
						<button className="registration-langauge-item small">
							+{sortedLanguages.length - 10}
						</button>
					)}
				</div>
			</div>
		</div>
	);
};

export default RegistrationStepsHeader;